import React, { FC } from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const Checkmark: FC<Props> = props => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      clipRule="evenodd"
      d="M10.7037 5.20297L6.91913 9.25055L5.23712 7.44916C4.99214 7.19254 4.82913 7.24378 4.56227 7.49363L4.18848 7.89952C3.93283 8.20148 3.94496 8.41251 4.17818 8.6501L6.62337 11.2744C6.77742 11.4419 7.06106 11.4419 7.21512 11.2744L11.7939 6.37055C12.0572 6.07545 12.0799 5.92479 11.7939 5.60884L11.4046 5.19185C11.15 4.92627 10.9467 4.94248 10.7037 5.20297Z"
      fill="#32395A"
      fillRule="evenodd"
    />
  </svg>
);

export default Checkmark;
